import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import PropTypes from "prop-types";
import api from "../../api/api";
// MUI
import { InputLabel, FormControl, Select, Box, MenuItem, useTheme, Typography } from "@mui/material";

import { usertype_change, program_change, clas_change, level_change, subject_change, question_change } from "./AudioAssessment.Slice";
import { getAssessmentQuestionThunk } from "./AudioAssessment.Thunk";

const Collection = () => {
  const dispatch = useDispatch();
  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];
  const program_select_option_list = [
    { value: "ece", text: "ECE" },
    { value: "pge", text: "PGE" },
  ];

  const clas_select_option_list = [
    { value: "1", text: "ଶ୍ରେଣୀ ୧" },
    { value: "2", text: "ଶ୍ରେଣୀ ୨" },
    { value: "3", text: "ଶ୍ରେଣୀ ୩" },
    { value: "4", text: "ଶ୍ରେଣୀ ୪" },
    { value: "5", text: "ଶ୍ରେଣୀ ୫" },
    { value: "6", text: "ଶ୍ରେଣୀ ୬" },
    { value: "7", text: "ଶ୍ରେଣୀ ୭" },
    { value: "8", text: "ଶ୍ରେଣୀ ୮" },
  ];
  const level_select_option_list = [
    { value: "1", text: "Level 1 (Age 3-4 Years)" },
    { value: "2", text: "Level 2 (Age 4-5 Years)" },
    { value: "3", text: "Level 3 (Balvatika)" },
  ];
  const subject_select_option_list = [
    { value: "maths", text: "Maths" },
    { value: "english", text: "English" },
    { value: "odia", text: "Odia" },
  ];
  const question_select_option_list = useSelector((state) => state.AudioAssessmentSlice.question);
  // console.log("question_select_option_list", question_select_option_list);

  // ---------------------------------------------

  // ------------ Load data & skill ----------------

  const usertype = useSelector((state) => state.AudioAssessmentSlice.usertype);
  const program = useSelector((state) => state.AudioAssessmentSlice.program);
  const level = useSelector((state) => state.AudioAssessmentSlice.level);
  const question = useSelector((state) => state.AudioAssessmentSlice.question);
  console.log("question", question);
  const subject = useSelector((state) => state.AudioAssessmentSlice.subject);
  console.log("subject================>", subject);
  const clas = useSelector((state) => state.AudioAssessmentSlice.clas);
  const questionId = useSelector((state) => state.ExtraQuizSlice.questionId);
  // console.log("questionId----->", questionId);

  const [questionData, setQuestionData] = useState([]);
  const [questions, setQuestion] = useState([]);
  // -----------------------------------------------

  const data = useSelector((state) => state.AudioAssessmentSlice.data);
  console.log("data=-->", data);

  // ------------ dropdowns on change ----------------
  const usertpe_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };
  const program_select_onchange = (event) => {
    dispatch(program_change(event.target.value));
  };
  const clas_select_onchange = (event) => {
    dispatch(clas_change(event.target.value));
  };
  const level_select_onchange = (event) => {
    dispatch(level_change(event.target.value));
  };
  const subject_select_onchange = (event) => {
    dispatch(subject_change(event.target.value));
    api.get(`getMasterStudentAudioAssessmentQuestions/${usertype}/${program}/${clas}/${event.target.value}`).then((response) => {
      console.log("question response--->", response);
      setQuestionData(response.data);
    });
  };

  const [selectedQuestion, setSelectedQuestion] = useState("");
  const question_select_onchange = (event, value) => {
    // setSelectedQuestion(event.target.value)
    dispatch(
      question_change({
        questionId: event.target.value,
        question: value.props.children,
      })
    );
    api.get(`getStudAudioAssessDataForEvaluation/${usertype}/${program}/${clas}/${subject}/${event.target.value}`).then((response) => {
      console.log("content question--->", response);
      setQuestion(response.data);
    });
  };

  return (
    <>
      <div>
        <FormControl sx={{ m: 1, width: 150, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">UserType</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={usertype} label="UserType" onChange={usertpe_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 150, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Program</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={program} label="Program" onChange={program_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {program_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {program == "ece" ? (
          <FormControl sx={{ m: 1, width: 150, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Level</InputLabel>
            <Select labelId="demo-select-small" id="demo-select-small" value={level} label="Level" onChange={level_select_onchange}>
              <MenuItem value="">None</MenuItem>
              {level_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <FormControl sx={{ m: 1, width: 150, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Class</InputLabel>
            <Select labelId="demo-select-small" id="demo-select-small" value={clas} label="Class" onChange={clas_select_onchange}>
              <MenuItem value="">None</MenuItem>
              {clas_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl sx={{ m: 1, width: 150, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Subject</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={subject} label="Subject" onChange={subject_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {subject_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 150, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Question</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={questionId} label="Question" onChange={question_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {questionData.map((option) => (
              <MenuItem key={option.questionId} value={option.questionId}>
                {option.question}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};
export default Collection;
